__turbopack_context__.v({
  "sectionContainer": "auzf8G_sectionContainer",
});
